import React from "react";

const Gmail = () => {
    return (
        <div className="main">
            <h1>Gmail</h1>
        </div>
    );
};

export default Gmail;
